import { reducer as apiv3 } from "data/reducers/apiv3";
import { localeReducer as locale } from "data/reducers/locale";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  apiv3,
  locale,
});
